import styled from "styled-components";

export const NotFoundPageContainer = styled.div`
  padding: 150px 0 65px 0;
  max-width: 1230px;
  width: 100%;
  margin: 0 auto;
 
  @media(max-width: 768px) {
    padding: 190px 0 65px 0;
  }
`;
export const NotFoundPageWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;

  @media(max-width: 630px){
    flex-wrap: wrap;
  }

`;
export const StyledNotFounfImage = styled.img`
    width: 100%;
    height: auto;  
    max-width: 445px;  
    object-fit: contain; 

    @media(max-width: 1024px){
        max-width: 295px;   
    }
`;
export const NotFoundPageContent = styled.div`
  max-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 80px;
  margin-right: 100px;
  margin-left: 10px;

  @media(max-width: 1024px){
    margin-right: 10px;
  }

  @media(max-width: 768px){
    max-width: 287px;
  } 

  @media(max-width: 630px){
    margin-top: 30px;
    margin-left: 0px;
  } 

`;

export const NotFoundIcon = styled.img`
  width: 220px;
  margin: 0 auto;

  @media(max-width: 1024px){
    width: 197px;
  }
  @media(max-width: 630px){
    width: 135px;
  }

`

export const Title = styled.div`
  font-family: "e-Ukraine-Head", sans-serif;
  font-weight: 400;
  font-size: 24px;
  line-height: 122%;
  color: #484848;
  margin: 30px 0 -8px 0;

  @media(max-width: 1024px){
    font-size: 23px;
    margin: 15px 0 -8px 0;
  }
`;
export const Subtitle = styled.div`
  font-family: "e-Ukraine", sans-serif;
  font-weight: 300;
  font-size: 17px;
  line-height: 122%;
  color: #484848;

  @media(max-width: 1024px){
    font-size: 13px;
  }
`;
export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 11px;
`;
